import type { QueryClient } from '@tanstack/react-query';

import type { Conversation } from '../inbox-types';
import { INBOX_MAX_TAKE, fetchConversations } from './inbox-api';
import { inboxKeys } from './use-whatsapp-inbox';

/** How far before the event's time the read looks (the server stamps rows after a patient lookup). */
export const CHANGED_LOOKBACK_MS = 60_000;

/**
 * The conversation a `WhatsAppInboxChanged` event names, read through the existing list route (`updatedAfter`):
 * the inbox API checks the caller's permission, and the event itself carries ids only. Null when it is not in
 * the first page or the read fails (the toast then says only "New WhatsApp message").
 */
export async function readChangedConversation(qc: QueryClient, conversationId: string, at: string): Promise<Conversation | null> {
  const atMs = Date.parse(at);
  const since = new Date((Number.isFinite(atMs) ? atMs : Date.now()) - CHANGED_LOOKBACK_MS).toISOString();
  try {
    return await qc.fetchQuery({
      queryKey: [...inboxKeys.all, 'changed', conversationId, at],
      queryFn: async ({ signal }) => {
        const page = await fetchConversations({ take: INBOX_MAX_TAKE, updatedAfter: since, signal });
        return page.items.find((c) => c.id === conversationId) ?? null;
      },
      staleTime: 0,
      gcTime: 0,
      retry: false,
      meta: { skipGlobalError: true },
    });
  } catch {
    return null;
  }
}
